module.exports = __webpack_public_path__ + "assets/186a9b8fbf030f45b00664b7081da5b0.png";